import { createContext, useContext } from 'react'
import { observable, action } from 'mobx'

class LoadingStore {
    @observable isLoading: boolean = true
    @action setLoading = (isLoading: boolean) => (this.isLoading = isLoading)
}

const loadingStoreContent = createContext(new LoadingStore())
const useLoadingStore = () => useContext(loadingStoreContent)

export default useLoadingStore
